import { Dispatch, FC } from 'react';
import OptionalWidthModal from '../../commons/optional-width-modal/OptionalWidthModal';
import DesactiveDateForm from '../forms/Client/DesactiveDateForm';
import { AxiosInstance } from 'axios';
import { AlertType } from '../../types/AlertType';

interface DesactiveDateModalProps {
    desactiveDateModal: boolean;
    url: string;
    confirmMessage: string;
    handleClose2: () => void;
    http: AxiosInstance;
    setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
    setAlerteMessage: Dispatch<React.SetStateAction<string>>;
    setAlertType: Dispatch<React.SetStateAction<AlertType>>;
    handleReload: () => void;
};

const DesactiveDateModal: FC<DesactiveDateModalProps> = ({
    desactiveDateModal,
    url,
    confirmMessage,
    handleClose2,
    http,
    setOpenSnack,
    setAlerteMessage,
    setAlertType,
    handleReload
}) => {

    return (
        <>
            <OptionalWidthModal
                open={desactiveDateModal}
                title="Date de désactivation"
                onClose={handleClose2}
            >
                <DesactiveDateForm
                    http={http}
                    url={url}
                    confirmMessage={confirmMessage}
                    setOpenSnack={setOpenSnack}
                    setAlerteMessage={setAlerteMessage}
                    setAlertType={setAlertType}
                    handleReload={handleReload}
                    handleClose2={handleClose2}
                />
            </OptionalWidthModal>
        </>
    );
};

export default DesactiveDateModal;